export default "__VITE_ASSET__XHESD1xB__"